import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../theme';

export default function CTA() {
  const { p, d, fonts } = useTheme();
  const navigate = useNavigate();

  return (
    <section style={{
      padding: `${d.hero * 1.1}px ${d.pad}px`, textAlign: 'center',
      borderBottom: `1px solid ${p.border}`,
    }}>
      <div style={{ maxWidth: 780, margin: '0 auto' }}>
        <div style={{
          fontFamily: fonts.mono, fontSize: 11, color: p.textDim,
          letterSpacing: '.18em', marginBottom: 24,
        }}>
          $ usertags --search "your_old_name"
        </div>
        <h2 style={{
          fontFamily: fonts.serif, fontSize: 84, fontWeight: 400, letterSpacing: '-.04em',
          lineHeight: .96, color: p.textHi, margin: '0 0 24px',
        }}>
          They're <span style={{ fontStyle: 'italic', color: p.accent }}>still</span><br />
          out there.
        </h2>
        <p style={{
          fontFamily: fonts.sans, fontSize: 17, color: p.text, lineHeight: 1.55,
          margin: '0 auto 36px', maxWidth: 480,
        }}>
          Free to search. Free to file. About thirty seconds. Built by two people who lost touch with their PS2 squad and wanted to find them.
        </p>
        <div style={{ display: 'inline-flex', gap: 10 }}>
          <span
            onClick={() => navigate('/search-tags')}
            style={{
              padding: '14px 28px', background: p.accent, color: p.bg,
              fontFamily: fonts.mono, fontSize: 13, fontWeight: 600, letterSpacing: '.06em', cursor: 'pointer',
            }}
          >
            SEARCH THE INDEX →
          </span>
          <span
            onClick={() => navigate('/make-a-tag')}
            style={{
              padding: '14px 28px', border: `1px solid ${p.borderHi}`, color: p.text,
              fontFamily: fonts.mono, fontSize: 13, letterSpacing: '.06em', cursor: 'pointer',
            }}
          >
            FILE A TAG
          </span>
        </div>
      </div>
    </section>
  );
}
